import { Route, Routes } from "react-router-dom";
import ContactUs from "../PublicComponents/pages/ContactUs";
import Home from "../PublicComponents/pages/Home";

function MainRoutes() {

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/contact" element={<ContactUs />} />
    </Routes>
  );
}

export default MainRoutes;
